import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import {
    EMPHASIZED_ACCELERATE_EASING,
    EMPHASIZED_DECELERATE_EASING,
} from "app/pages/sales-intelligence/common-components/animations";
import { withSWReactIconFillColor } from "app/pages/sales-intelligence/common-components/styles";

export const BANNER_ENTER_DURATION_MS = 400;
const BANNER_EXIT_DURATION_MS = 280;
const BANNER_FADE_IN_DURATION_MS = 220;
// Holds the copy back until the banner has most of its height, so it is never read inside a squashed box.
const BANNER_FADE_IN_DELAY_MS = 140;
const BANNER_FADE_OUT_DURATION_MS = 140;

// Animation wrapper (not layout): `grid-template-rows: 0fr↔1fr` animates the banner's intrinsic height so the
// page doesn't shift sharply on enter/exit — robust to one- or two-line copy, no measurement needed.
//
// Enter and exit are deliberately not the same motion. Arriving is slower and decelerates, so the page reflow
// is easy to follow; leaving is quicker and accelerates, so dismissing feels immediate. The copy fades on its
// own schedule rather than in lockstep with the height: in behind the expansion, out ahead of the collapse.
export const AnimatedBannerContainer = styled.div<{ $isOpen: boolean }>`
    display: grid;
    grid-template-rows: ${({ $isOpen }) => ($isOpen ? "1fr" : "0fr")};
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    transition: ${({ $isOpen }) =>
        $isOpen
            ? `
                  grid-template-rows ${BANNER_ENTER_DURATION_MS}ms ${EMPHASIZED_DECELERATE_EASING},
                  opacity ${BANNER_FADE_IN_DURATION_MS}ms linear ${BANNER_FADE_IN_DELAY_MS}ms
              `
            : `
                  grid-template-rows ${BANNER_EXIT_DURATION_MS}ms ${EMPHASIZED_ACCELERATE_EASING},
                  opacity ${BANNER_FADE_OUT_DURATION_MS}ms linear
              `};

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
`;

export const AnimatedBannerRow = styled.div`
    overflow: hidden;
    min-height: 0;
`;

export const DemoModeBannerWrapper = styled(Flex)`
    position: relative;
    width: 100%;
    padding: 12px 48px;
    background-color: ${colorsPalettes.blue[500]};
`;

// Passed to the CTA's `Button` and reserved here, so the banner keeps its height once the CTA removes itself.
export const CTA_HEIGHT_PX = 37;

export const DemoModeBannerContent = styled(Flex)`
    flex: 1;
    min-height: ${CTA_HEIGHT_PX}px;
    align-items: center;
    justify-content: center;
    gap: 16px;
`;

export const DemoModeCloseButton = styled(IconButton)`
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);

    ${withSWReactIconFillColor(colorsPalettes.carbon[0])}
`;
